import ExerciseGenerator from "./ExerciseGenerator";
import {/*getRandomIntegerWithinBitCount,*/ getRandomIntegerWithRange} from "../Random";
import Exercise from "../Exercise";
//import {binaryToDecimal, decimalToBinary} from "../logic/Conversion";
import Modes from "../mode/Modes";
import ResultItem from "../ResultItem";
import NumberSystems from "../NumberSystems";

export default class SignBitExerciseGenerator extends ExerciseGenerator{
    generate = (task) => {
        this.bitCount = this.getRandomBitCount();
        if(!task){
            task = getRandomIntegerWithRange(-127, 128)
        }

        if(this.mode.equals(Modes.DECIMAL_TO_BINARY_SIGN_BIT_8_BIT)) {
            return this.decimalToBinary(task, this.bitCount);
        }
        else if(this.mode.equals(Modes.BINARY_SIGN_BIT_TO_DECIMAL_8_BIT)){
            return this.binaryToDecimal(task, this.bitCount);
        }
        else {
            console.error(this.mode);
            throw new Error("Unknown mode");
        }
    };

    decimalToBinary = (task, bitCount) => {
        const result = [new ResultItem(this.signBit(task, bitCount), NumberSystems.BINARY)];

        return new Exercise([task], [String(task)], result);
    };

    binaryToDecimal = (task, bitCount) => {
        const convertedTask = [this.signBit(task, bitCount)];

        return new Exercise(
            [task],
            convertedTask,
            [
                new ResultItem(task, NumberSystems.DECIMAL, true, true)
            ]
        );
    }

}